var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArticlePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2698_1038",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2698_1038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75033 9.91669H19.2503V8.75002H8.75033V9.91669ZM6.55174 23.3334C6.02966 23.3334 5.58496 23.1498 5.21766 22.7827C4.85055 22.4154 4.66699 21.9707 4.66699 21.4486V6.55144C4.66699 6.02935 4.85055 5.58466 5.21766 5.21735C5.58496 4.85024 6.02966 4.66669 6.55174 4.66669H21.4489C21.971 4.66669 22.4157 4.85024 22.783 5.21735C23.1501 5.58466 23.3337 6.02935 23.3337 6.55144V11.6982C22.8715 11.1821 22.327 10.7787 21.7003 10.4878C21.0736 10.1969 20.4065 10.0514 19.6989 10.0514C18.6295 10.0514 17.6633 10.3602 16.8003 10.9778C15.9374 11.5955 15.3204 12.4085 14.9494 13.4167H8.75033V14.5834H14.6128C14.544 15.1068 14.5665 15.6229 14.6802 16.1315C14.7938 16.64 14.9785 17.1261 15.2344 17.5899C15.0399 17.6645 14.8492 17.7393 14.6621 17.8141C14.4753 17.889 14.2921 17.9787 14.1126 18.0834H8.75033V19.25H12.8135C12.4291 19.6628 12.1419 20.138 11.952 20.6757C11.762 21.2135 11.667 21.7644 11.667 22.3283V23.3334H6.55174ZM14.4489 23.3334V22.2834C14.4489 21.9213 14.5406 21.5934 14.7239 21.2996C14.9071 21.0056 15.1625 20.7935 15.4902 20.6634C16.1452 20.3867 16.8246 20.1793 17.5283 20.041C18.232 19.9026 18.9555 19.8334 19.6989 19.8334C20.4125 19.8334 21.1212 19.9026 21.8249 20.041C22.5286 20.1793 23.2229 20.3867 23.9079 20.6634C24.2356 20.7935 24.491 21.0056 24.6742 21.2996C24.8573 21.5934 24.9489 21.9213 24.9489 22.2834V23.3334H14.4489ZM19.6989 17.5C19.0619 17.5 18.5138 17.2704 18.0545 16.8111C17.5952 16.352 17.3656 15.8039 17.3656 15.1667C17.3656 14.5295 17.5952 13.9814 18.0545 13.5223C18.5138 13.063 19.0619 12.8334 19.6989 12.8334C20.3361 12.8334 20.8843 13.063 21.3436 13.5223C21.8027 13.9814 22.0322 14.5295 22.0322 15.1667C22.0322 15.8039 21.8027 16.352 21.3436 16.8111C20.8843 17.2704 20.3361 17.5 19.6989 17.5Z",
    fill: "#ADC9FE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlePerson);
export default __webpack_public_path__ + "static/media/article_person.62ed500a6221c94a96c40466c764abb0.svg";
export { ForwardRef as ReactComponent };